/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assignment_Group_Invalid_PeriodInputs */

const fr_assignment_group_invalid_period = /** @type {(inputs: Assignment_Group_Invalid_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une date de début et une date de fin égale ou postérieure pour chaque groupe sélectionné.`)
};

const en_assignment_group_invalid_period = /** @type {(inputs: Assignment_Group_Invalid_PeriodInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a start date and an end date on or after it for each selected group.`)
};

/**
* | output |
* | --- |
* | "Choose a start date and an end date on or after it for each selected group." |
*
* @param {Assignment_Group_Invalid_PeriodInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const assignment_group_invalid_period = /** @type {((inputs?: Assignment_Group_Invalid_PeriodInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assignment_Group_Invalid_PeriodInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_assignment_group_invalid_period(inputs)
	return fr_assignment_group_invalid_period(inputs)
});